function init(button, element) {
	var $button = $(button),
		$element = $(element);
	
	if ($button) {
		$button.on('click', function(event) {
			$(this).hide();
			event.preventDefault();
			$element.toggle();
		});
	}
	
}

export default {
	init
};